import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'a-title-label',
    templateUrl: './a-title-label.component.html',
    styleUrls: ['./a-title-label.component.scss'],
    standalone: false
})
export class ATitleLabelComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}
